import React from "react";
import _ from "lodash";
import { FiPlus, FiMinus } from "react-icons/fi";

class GroupDataTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mainExpandList: [],
      subExpandList: [],
    };
  }

  render() {
    const {
      header,
      columns,
      mainKey,
      subKey = "",
      records,
      groups,
      amount,
    } = this.props;

    const { mainExpandList, subExpandList } = this.state;

    // if subKey is empty and records is the same as groups[0], means all data is expanded displayed
    const allExpanded =
      subKey === "" && _.flatten(records).length === (groups[0] || []).length;

    const allMainExpanded = _.every(groups[0], (item) => item.count === 1);

    // records is the original data
    // groups is the grouped data
    // groups[0] is the main group by mainKey
    // groups[1] is the sub group by subKey
    // tableData is the final data to be displayed in the table

    // so if mainkey is in mainExpandList, then put corresponding groups[0] data in tableData
    // if subkey is in subExpandList, then put corresponding groups[1] data in tableData
    // else put corresponding records data in tableData

    // subfirst and mainfirst are used to indicate if the row is the first row of the group
    // first row need to set rowSpan
    const tableData = [];
    _.forEach(_.cloneDeep(records), (mList, mIdx) => {
      const mainItem = groups[0][mIdx];
      if (allMainExpanded || _.includes(mainExpandList, mainItem[mainKey])) {
        if (subKey !== "") {
          _.forEach(mList, (sList, sIdx) => {
            const subItem = groups[1][mIdx][sIdx];
            const subId = `${subItem[mainKey]}-${subItem[subKey]}`;
            if (_.includes(subExpandList, subId)) {
              const temp = [...sList];
              temp[0].subfirst = true;
              if (sIdx === 0) temp[0].mainfirst = true;
              tableData.push(...sList);
            } else {
              const temp = { ...subItem };
              temp.subfirst = true;
              if (sIdx === 0) temp.mainfirst = true;
              tableData.push(temp);
            }
          });
        } else {
          const temp = [...mList];
          temp[0].mainfirst = true;
          if (subKey !== "") temp[0].subfirst = true;
          tableData.push(...temp);
        }
      } else {
        const temp = { ...mainItem };
        temp.mainfirst = true;
        if (subKey !== "") temp.subfirst = true;
        tableData.push(temp);
      }
    });

    return (
      <table className="border shadow table w-full text-sm">
        <thead className="border-b bg-gray-300 text-xs text-blue-800">
          {header}
          <tr>
            {columns.map((col, idx) => {
              if (col.hide) return null;
              if (!allExpanded && (col.key === mainKey || col.key === subKey)) {
                return (
                  <React.Fragment key={`th-${idx}`}>
                    <th className="border px-2 py-1 text-center">
                      {!allMainExpanded && col.key === mainKey && (
                        <ExpandButton
                          expand={mainExpandList.length > 0}
                          onClick={() => {
                            this.setState(() => ({
                              mainExpandList:
                                mainExpandList.length > 0
                                  ? []
                                  : _.map(tableData, (d) => d[mainKey]),
                            }));
                          }}
                        ></ExpandButton>
                      )}
                      {col.key === subKey &&
                        (allMainExpanded || mainExpandList.length > 0) && (
                          <ExpandButton
                            expand={subExpandList.length > 0}
                            onClick={() => {
                              this.setState(() => ({
                                subExpandList:
                                  subExpandList.length > 0
                                    ? []
                                    : _.map(
                                        tableData,
                                        (d) => `${d[mainKey]}-${d[subKey]}`
                                      ),
                              }));
                            }}
                          ></ExpandButton>
                        )}
                    </th>
                    <th
                      className={`border px-2 py-1 text-center ${
                        col.align || ""
                      }`}
                      key={`th-${idx}`}
                    >
                      {col.label}
                    </th>
                  </React.Fragment>
                );
              } else {
                return (
                  <th
                    className={`border px-2 py-1 text-center ${
                      col.align || ""
                    }`}
                    key={`th-${idx}`}
                  >
                    {col.label}
                  </th>
                );
              }
            })}
          </tr>
        </thead>
        <tbody className="bg-white text-gray-900">
          {amount && (
            <tr className="border-b bg-blue-100 font-semibold" key="row-amount">
              {columns.map((col, idx) => {
                if (col.hide) return null;
                if (!allExpanded && col.key === mainKey) {
                  return (
                    <React.Fragment key={`main-amount-${idx}`}>
                      <td className="border px-2 py-1 text-center"></td>
                      <td
                        className={`border px-2 py-1 text-center ${
                          col.align || ""
                        }`}
                      >
                        {idx === 0 ? "Total" : amount[col.key]}
                      </td>
                    </React.Fragment>
                  );
                } else if (!allExpanded && col.key === subKey) {
                  return (
                    <React.Fragment key={`main-amount-${idx}`}>
                      <td className="border px-2 py-1 text-center"></td>
                      <td
                        className={`border px-2 py-1 text-center ${
                          col.align || ""
                        }`}
                      >
                        {idx === 0 ? "Total" : amount[col.key]}
                      </td>
                    </React.Fragment>
                  );
                } else {
                  return (
                    <td
                      className={`border px-2 py-1 text-center ${
                        col.align || ""
                      }`}
                      key={`amount-${col.key}-${idx}`}
                    >
                      {idx === 0 ? (
                        "Total"
                      ) : (
                        <>
                          {col.format
                            ? col.format(amount[col.key])
                            : amount[col.key]}
                        </>
                      )}
                    </td>
                  );
                }
              })}
            </tr>
          )}
          {tableData.map((item, rIdx) => {
            const isMainExpand =
              allMainExpanded || _.includes(mainExpandList, item[mainKey]);

            const isSubExpand =
              subKey !== "" &&
              _.includes(subExpandList, `${item[mainKey]}-${item[subKey]}`);

            return (
              <tr
                className={`border-b hover:bg-gray-100 
                  ${isMainExpand || item.count === 1 ? "" : "bg-gray-200"}
                  ${isSubExpand || item.count === 1 ? "" : "bg-gray-100"}`}
                key={`row-${rIdx}`}
              >
                {columns.map((col, idx) => {
                  if (col.hide) return null;
                  if (!allExpanded && col.key === mainKey) {
                    if (item.mainfirst) {
                      const mainSpan = _.filter(
                        tableData,
                        (d) => d[mainKey] === item[mainKey]
                      ).length;
                      return (
                        <React.Fragment key={`main-${rIdx}-${idx}`}>
                          <td
                            className="border px-2 py-1 text-center"
                            rowSpan={mainSpan}
                          >
                            {!allMainExpanded &&
                            (item.count > 1 || mainSpan > 1) ? (
                              <ExpandButton
                                expand={isMainExpand}
                                onClick={() => {
                                  this.setState(() => ({
                                    mainExpandList: _.xor(mainExpandList, [
                                      item[mainKey],
                                    ]),
                                  }));
                                }}
                              ></ExpandButton>
                            ) : (
                              "--"
                            )}
                          </td>
                          <td
                            className={`border px-2 py-1 text-center ${
                              col.align || ""
                            }`}
                            rowSpan={mainSpan}
                          >
                            {item[col.key]}
                          </td>
                        </React.Fragment>
                      );
                    } else {
                      return null;
                    }
                  } else if (!allExpanded && col.key === subKey) {
                    if (item.subfirst) {
                      const subSpan = _.filter(
                        tableData,
                        (d) =>
                          d[mainKey] === item[mainKey] &&
                          d[subKey] === item[subKey]
                      ).length;
                      return (
                        <React.Fragment key={`sub-${rIdx}-${idx}`}>
                          <td
                            className="border px-2 py-1 text-center"
                            rowSpan={subSpan}
                          >
                            {isMainExpand && (item.count > 1 || subSpan > 1) ? (
                              <ExpandButton
                                expand={isSubExpand}
                                onClick={() => {
                                  const id = `${item[mainKey]}-${item[subKey]}`;
                                  this.setState(() => ({
                                    subExpandList: _.xor(subExpandList, [id]),
                                  }));
                                }}
                              ></ExpandButton>
                            ) : (
                              "--"
                            )}
                          </td>
                          <td
                            className={`border px-2 py-1 text-center ${
                              col.align || ""
                            }`}
                            rowSpan={subSpan}
                          >
                            {item[col.key]}
                          </td>
                        </React.Fragment>
                      );
                    } else {
                      return null;
                    }
                  } else if (col.mainGroup) {
                    if (item.mainfirst) {
                      const mainSpan = _.filter(
                        tableData,
                        (d) => d[mainKey] === item[mainKey]
                      ).length;
                      const gIndex = _.findIndex(
                        groups[0],
                        (d) => d[mainKey] === item[mainKey]
                      );
                      return (
                        <td
                          className={`border px-2 py-1 text-center ${
                            col.align || ""
                          }`}
                          rowSpan={mainSpan}
                          key={`col-${rIdx}-${idx}`}
                        >
                          {groups[0][gIndex][col.key]}
                        </td>
                      );
                    } else {
                      return null;
                    }
                  } else {
                    return (
                      <td
                        className={`border px-2 py-1 text-center ${
                          col.align || ""
                        }`}
                        key={`col-${rIdx}-${idx}`}
                      >
                        {col.format ? col.format(item[col.key]) : item[col.key]}
                      </td>
                    );
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

class ExpandButton extends React.Component {
  render() {
    const { expand, onClick } = this.props;
    return (
      <div className="flex items-center justify-center" onClick={onClick}>
        <div className="flex h-4 w-4 cursor-pointer items-center justify-center rounded-sm bg-gray-600 py-1 text-xs font-normal text-white">
          {expand ? <FiMinus /> : <FiPlus />}
        </div>
      </div>
    );
  }
}

export default GroupDataTable;
